import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/team/title.png'
import _imports_1 from '@/assets/image/team/title2.png'


const _withScopeId = n => (_pushScopeId("data-v-1f903944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-index" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img1",
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "img2",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode()
const _hoisted_6 = { class: "introduce" }
const _hoisted_7 = { class: "person" }
const _hoisted_8 = { class: "flex-item" }
const _hoisted_9 = { class: "tag" }
const _hoisted_10 = { class: "name" }
const _hoisted_11 = { class: "c-name" }
const _hoisted_12 = { class: "flex2" }
const _hoisted_13 = { class: "flex-item" }
const _hoisted_14 = { class: "img" }
const _hoisted_15 = { class: "tag" }
const _hoisted_16 = { class: "r-desc" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "c-name" }
const _hoisted_19 = { class: "right-desc" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-title" }, "擅长领域", -1))
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = { class: "field mt30" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "field-title" }, "典型案例", -1))
const _hoisted_25 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_right_outlined = _resolveComponent("right-outlined")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, [
          _createElementVNode("span", {
            class: "tit_span",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.tocoreTeam && _ctx.tocoreTeam(...args)))
          }, _toDisplayString(_ctx.title), 1),
          _hoisted_5,
          _createVNode(_component_right_outlined),
          _createElementVNode("span", null, _toDisplayString(_ctx.titleName), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "img",
              style: _normalizeStyle({backgroundImage:`url(${_ctx.dataSource.img})`,})
            }, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.dataSource.tag), 1)
            ], 4),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.titleName), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "bg",
                style: _normalizeStyle({backgroundImage:`url(${_ctx.dataSource.img})`})
              }, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.dataSource.tag), 1)
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.titleName), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", {
              class: "richText",
              innerHTML: _ctx.dataSource.field
            }, null, 8, _hoisted_22)
          ]),
          _createElementVNode("div", _hoisted_23, [
            _hoisted_24,
            _createElementVNode("div", {
              class: "richText",
              innerHTML: _ctx.dataSource.work
            }, null, 8, _hoisted_25)
          ])
        ])
      ])
    ])
  ]))
}